export const generateKey = (): string =>
	Math.random().toString(32).substring(2);
